import '../../styles.scss';
import { Button } from 'semantic-ui-react';
import Messages from '../Messages';
import { usePortfolioContext } from '~/hooks';
import { DealSummaryInvestorData } from '~/types/portfolio/PortfolioDealSummary';
import useArchiveToastCheck from '~/hooks/archive/useArchiveToastCheck';

interface ActionButtonProps {
  investor: DealSummaryInvestorData;
  awaitingBid: boolean;
  setAcceptInvestorId?: (id: string) => void;
}

const ActionsButton = ({ 
  investor, 
  awaitingBid,
  setAcceptInvestorId, 
}: ActionButtonProps) => {
  const { portfolio } = usePortfolioContext();

  const handleClick = useArchiveToastCheck(() => setAcceptInvestorId?.(investor?.id));  

  return (
    <>
      {awaitingBid ? (
        <Button size="small" className='small portfolio-button'>
          <Messages
            portfolio={portfolio}
            investor={investor}
            awaitingBid={awaitingBid}
          />
        </Button>
      ) : (
        <Button
          className='portfolio-button'
          size="small"
          onClick={() => handleClick()}
        >
          Accept bid
        </Button>
      )}
    </>
  );
};

export default ActionsButton;